module.exports = __webpack_public_path__ + "static/media/i-crescent-rainbow.13fe590d.svg";